import styled from "styled-components";
import { theme } from "../../theme";

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: clamp(2rem, 5vw, 4rem) 1.5rem;
  color: ${theme.colors.primary};
`;

export const Hero = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const Photo = styled.img`
  width: 500px;
  height: 500px;
  border-radius: 30%;
  object-fit: cover;
  border: 6px solid #d4af37;
  box-shadow: 0 0 30px rgba(212, 175, 55, .35);

  @media (max-width:768px){
    width:200px;
    height:200px;
  }
`;

export const PhotoPlaceholder = styled.div`
  width:260px;
  height:260px;
  border-radius:50%;
  border:4px dashed #d4af37;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size:1.2rem;
  font-weight:bold;
  color:#d4af37;

  @media(max-width:768px){
    width:200px;
    height:200px;
  }
`;

export const HeroText = styled.div`
  width: 100%;
  min-width: 0;
`;

export const SmallTitle = styled.p`
  font-size:1rem;
  letter-spacing:3px;
  text-transform:uppercase;
  color:#c9a227;
`;

export const Title = styled.h1`
  font-size:clamp(2.2rem,5vw,3.8rem);
  margin:.3rem 0;
`;

export const Subtitle = styled.h2`
  font-size:1.4rem;
  color:white;
  font-weight:400;
  margin-bottom:2rem;
`;

export const Paragraph = styled.p`
  font-size:1.4rem;
  line-height:1.9;
  color:#f2f2f2;
  margin-bottom:1.5rem;
`;

export const SectionTitle = styled.h2`
  text-align:center;
  margin-bottom:2rem;
  font-size:2rem;
`;

export const Grid = styled.div`
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
  gap:1.5rem;
  margin:3rem 0;
`;

export const Card = styled.div`
  background:rgba(255,255,255,.05);
  border:1px solid rgba(212,175,55,.25);
  border-radius:18px;
  padding:2rem;
  text-align:center;
  transition:.3s;

  &:hover{
      transform:translateY(-8px);
      border-color:#d4af37;
      box-shadow:0 0 25px rgba(212,175,55,.25);
  }
`;

export const Icon = styled.div`
  font-size:3rem;
  margin-bottom:1rem;
`;

export const CardTitle = styled.h3`
  margin-bottom:1rem;
  font-size:1.3rem;
`;

export const CardText = styled.p`
  color:#ddd;
  line-height:1.6;
`;

export const Quote = styled.div`
  margin:5rem auto;
  max-width:900px;
  text-align:center;
  padding:3rem;
  border-left:5px solid #d4af37;
  background:rgba(255,255,255,.04);
  border-radius:15px;

  p{
      font-size:1.5rem;
      line-height:1.7;
      font-style:italic;
      color:white;
  }
`;

export const ContactButton = styled.a`
  display:inline-block;
  margin-top:2rem;
  padding:16px 35px;
  background:#25D366;
  color:white;
  border-radius:50px;
  text-decoration:none;
  font-size:1.2rem;
  font-weight:700;
  transition:.3s;

  &:hover{
      transform:scale(1.06);
  }
`;

export const Center = styled.div`
  text-align:center;
`;
